module.exports = __webpack_public_path__ + "twitter-2f047fbe1af9e3dd814a.svg";